import PropTypes from 'prop-types';
import React from 'react';

import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import Form from '../../common/form/Form';
import Input from '../../common/input/Input';

import Api from '../../../../utils/api';


const SVG_FILE_PATH = '../../../../static/images/';

const REGISTRATION_STAGE = {
  phoneNumber: 'phone-number',
  otp: 'otp',
  complete: 'complete',
};

export default class FreeGiftCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stage: REGISTRATION_STAGE.phoneNumber,
      phoneNumber: null,
      requestId: null,
      otp: null,
    };

    this.phoneNumberInput = null;
    this.otpInput = null;
  }

  generateOtp(phoneNumber) {
    Api.generateOtp(phoneNumber)
      .then(response => this.setState({
        phoneNumber,
        requestId: response.request_id,
        stage: REGISTRATION_STAGE.otp,
      }));
  }

  registerMember(phoneNumber, requestId, otp) {
    Api.addMember({
      'request-id': requestId,
      otp,
    }, JSON.stringify({
      phone_number: phoneNumber,
      source: 'member',
    })).then(() => this.setState({ stage: REGISTRATION_STAGE.complete }));
  }

  processPhoneNumberStage() {
    let phoneNumber = this.state.phoneNumber;

    if (this.phoneNumberInput) {
      phoneNumber = this.phoneNumberInput.value;
    }

    if (phoneNumber) {
      this.generateOtp(phoneNumber);
    }

    if (this.phoneNumberInput) {
      this.phoneNumberInput.value = '';
    }
  }

  processOtpStage() {
    let otp = this.state.otp;

    if (this.otpInput) {
      otp = this.otpInput.value;
    }

    if (otp) {
      this.registerMember(this.state.phoneNumber, this.state.requestId, otp);
    }

    if (this.otpInput) {
      this.otpInput.value = '';
    }
  }

  renderMobileNumberCard() {
    const body = (
      <Card.Body>
        <p>
          Earn m.Paani points on every purchase with {this.props.storeName} & redeem gifts.
        </p>

        <Form
          onSubmit={(event) => {
            event.preventDefault();
            this.processPhoneNumberStage();
          }}
        >
          <Input
            defaultValue=""
            type="tel"
            placeholder="Enter Mobile Number"
            onBlur={event => this.setState({ phoneNumber: event.target.value })}
            inputRef={input => this.phoneNumberInput = input}
            fullWidth
            rounded
          />

          <Button
            label="Submit"
            onClick={() => this.processPhoneNumberStage()}
            fullWidth
          />
        </Form>
      </Card.Body>
    );

    return this.renderCard('', body);
  }

  renderOTPCard() {
    const body = (
      <Card.Body>
        <p>
          An OTP has been sent to your number {this.state.phoneNumber}. Enter your OTP here.
        </p>

        <Form>
          <Input
            defaultValue={this.state.otp}
            type="number"
            placeholder="OTP"
            onBlur={event => this.setState({ otp: event.target.value })}
            inputRef={input => this.otpInput = input}
            fullWidth
            rounded
          />
          <Button
            label="Submit OTP"
            onClick={() => this.processOtpStage()}
            fullWidth
          />
        </Form>
      </Card.Body>
    );

    return this.renderCard('Enter OTP', body);
  }

  renderCompletedCard() {
    const body = (
      <Card.Body>
        <p>
          You&rsquo;re now registered with m.Paani for free on {this.state.phoneNumber}.
        </p>

        <Form>
          <Button
            label="Enter new number"
            onClick={() => this.setState({ phoneNumber: null, stage: REGISTRATION_STAGE.phoneNumber })}
            fullWidth
          />
        </Form>
      </Card.Body>
    );

    return this.renderCard('Successful', body);
  }

  renderCard(title, body) {
    const footer = (
      <Card.Footer>
        <div className="clearfix" />
      </Card.Footer>);

    return (
      <Card>
        {!this.props.alternate ?
          <Card.Media
            media={<img alt="Member" src={`${SVG_FILE_PATH}add-person.svg`} />}
          /> : null}
        <Card.Content>
          <Card.Header
            media={this.props.alternate ?
              <img
                alt="Member"
                src={`${SVG_FILE_PATH}add-person.svg`}
              /> : null}
            title={this.props.title}
          />
          {body}
          {this.props.alternate ? footer : null}
        </Card.Content>
      </Card>);
  }

  render() {
    switch (this.state.stage) {
      case REGISTRATION_STAGE.phoneNumber:
        return this.renderMobileNumberCard();

      case REGISTRATION_STAGE.otp:
        return this.renderOTPCard();

      case REGISTRATION_STAGE.complete:
        return this.renderCompletedCard();

      default:
        return this.renderMobileNumberCard();
    }
  }
}

FreeGiftCard.propTypes = {
  storeName: PropTypes.string,
  alternate: PropTypes.bool,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/components/derived/card/FreeGiftCard.jsx